/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIPlanningEnum } from './APIPlanningEnum';
import {
    APIPlanningEnumFromJSON,
    APIPlanningEnumFromJSONTyped,
    APIPlanningEnumToJSON,
} from './APIPlanningEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIContactRequest
 */
export interface APIContactRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof APIContactRequest
     */
    addresses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIContactRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactRequest
     */
    mobile?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactRequest
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactRequest
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactRequest
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactRequest
     */
    comment?: string;
    /**
     * 
     * @type {APIPlanningEnum}
     * @memberof APIContactRequest
     */
    preferredContactMethod?: APIPlanningEnum | null;
}



/**
 * Check if a given object implements the APIContactRequest interface.
 */
export function instanceOfAPIContactRequest(value: object): value is APIContactRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function APIContactRequestFromJSON(json: any): APIContactRequest {
    return APIContactRequestFromJSONTyped(json, false);
}

export function APIContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'addresses': json['addresses'] == null ? undefined : json['addresses'],
        'email': json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'mobile': json['mobile'] == null ? undefined : json['mobile'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'language': json['language'] == null ? undefined : json['language'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'preferredContactMethod': json['preferred_contact_method'] == null ? undefined : APIPlanningEnumFromJSON(json['preferred_contact_method']),
    };
}

export function APIContactRequestToJSON(value?: APIContactRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'addresses': value['addresses'],
        'email': value['email'],
        'phone': value['phone'],
        'mobile': value['mobile'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'language': value['language'],
        'comment': value['comment'],
        'preferred_contact_method': APIPlanningEnumToJSON(value['preferredContactMethod']),
    };
}

